import { upsertEmaProduct } from '../../api/ema';
import type { UpsertEmaProductRequest } from '../../types/dtos/ema';

export type SubmitResult = { ok: true; productId: string } | { ok: false; error: string };

type OptionItem = { id: number; value: string };

type FormData = {
  pno: string;
  applno?: string;
  drugname: string;
  strength: string;
  packaging: string;
  concentration: string;
  packsize: string;
  activeingredient?: string;
  indication_status: 'Qced' | 'To Escalate' | 'To QC';
  is_active?: boolean;
  formulations: OptionItem[];
  routes: OptionItem[];
};

export const buildProductPayload = (
  formData: FormData,
  productNumber: string,
  curationId: string,
  productUrl: string,
  curatorEmail: string,
  curatorName: string
): UpsertEmaProductRequest => ({
  curation_id: curationId,
  pno: formData.pno,
  applno: productNumber,
  drugname: formData.drugname,
  strength: formData.strength,
  packaging: formData.packaging,
  concentration: formData.concentration,
  packsize: formData.packsize,
  activeingredient: formData.activeingredient ?? '',
  url: productUrl,
  sourced_from: productUrl,
  curator_email: curatorEmail,
  curator_name: curatorName,
  qc_date: new Date().toISOString().split('T')[0],
  indication_status: formData.indication_status,
  is_active: formData.is_active ?? true,
  formulation_ids: formData.formulations.map(f => f.id),
  route_ids: formData.routes.map(r => r.id)
});

export const submitEmaProductForm = async (
  productNumber: string,
  curationId: string,
  payload: UpsertEmaProductRequest
): Promise<SubmitResult> => {
  const result = await upsertEmaProduct(productNumber, curationId, payload);
  if ('error' in result) {
    return { ok: false, error: result.error };
  }
  return { ok: true, productId: result.id };
};
